"use strict";
var PromiseObservable_1 = require('./PromiseObservable');
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/rxjs/observable/fromPromise.js
// module id = ../../../../rxjs/observable/fromPromise.js
// module chunks = 3